import { Col, Container, Row } from "react-bootstrap";
import { Helmet, HelmetProvider } from 'react-helmet-async';
export function Howitworks() {
    return (

        <Container>
            <HelmetProvider>
                <Helmet>
                    <title>EnglishEditAI - How it Works</title>
                    <meta name="description" content="See how easy it is to submit text for editing. No cost, no log-in, no hassle!"></meta>
                </Helmet>
            </HelmetProvider>
            <Row>
                <Col></Col>
                <Col style={{ textAlign: "center" }}>
                    <h1>How it works</h1>
                </Col>
                <Col></Col>
            </Row>
            <Row className="mt-5">
                <h3>How does AI editing work?</h3>
                <p>
                    OpenAI's natural language processing models are equipped with approximately 175 billion parameters. They operate on thousands of GPUs housed in cloud-based servers. When users input text into our free writing tool, it is processed through billions of steps to ensure clarity, coherence, and accuracy.

                </p>
            </Row>
            <Row>
                <p>
                    OpenAI has trained the AI engine using an extensive collection of high-quality English texts. This training allows it to identify and correct grammatical and usage errors, such as misplaced modifiers, subject-verb agreement issues, and verb tense inconsistencies. Moreover, the engine comprehends the context of a sentence, offering suggestions to enhance sentence structure, word choice, and overall clarity.

                </p>
            </Row>
            <Row className="mt-3">
                <h3>How do I use the free writing tool?</h3>
                <p>
                    <ul>
                        <li><span style={{ fontWeight: 600 }}>Select a Prompt:</span> Begin by choosing a prompt from the provided list. For a more customized experience, you can combine multiple prompts or even create your own.</li>
                        <li><span style={{ fontWeight: 600 }}>Enter Your Text:</span> Once you've chosen a prompt, type or paste your text into the designated text box.</li>
                        <li><span style={{ fontWeight: 600 }}>Edit: Click the </span>“Edit My Text” button. Please be patient, as it may take a few seconds for the advanced AI system to process and refine your content.</li>
                        <li><span style={{ fontWeight: 600 }}>Review Changes:</span> After editing, the revised text will appear with changes highlighted. Additions will be marked in green, while deletions will be highlighted in red.</li>
                        <li><span style={{ fontWeight: 600 }}>Toggle Changes:</span> If you prefer not to see the color-coded modifications, you can disable this feature using the "Show Changes" checkbox.</li>
                        <li><span style={{ fontWeight: 600 }}>Copy & Paste:</span> To incorporate the edited text into your document, simply click the "Copy" button. This will place the revised content onto your clipboard for easy pasting.</li>
                        <li><span style={{ fontWeight: 600 }}>Start Fresh: </span>If you wish to edit a new piece of content, just click the "Clear" button to reset the tool.</li>

                    </ul>
                </p>
            </Row>
            <Row className="mt-3 mb-3" >
                <h3>Why is this tool free?</h3>
                <p>
                    For nearly two decades, the <a style={{ textDecoration: 'underline', color: '#9bc97f', fontWeight: 600 }} href="http://grammarlabs.com">Grammar Labs</a> team has been offering human-based editing services through our premium platform. As a gesture of gratitude to our loyal clientele,
                    we are now introducing a nearly instantaneous, advanced editing solution free of charge that harnesses
                    the power of the latest AI technology.
                </p>
            </Row>
        </Container>
    )
}